<ng-container *ngIf="!membership.is_group">

  <div class="form-group" *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
    <label for="initiationFeeInput">Initiation Fee *</label>
    <div class="row">
      <div class="input-group col-lg-3 col-md-4 col-sm-5">
        <div class="input-group-prepend">
          <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
        </div>
        <input id="initiationFeeInput" type="number" name="initiation_fee"
               placeholder="XXX.XX" min="0" step="0.01"
               class="form-control"
               [(ngModel)]="membership.initiation_fee"
               (ngModelChange)="changed.emit()">
      </div>
    </div>
    <div class="form-text text-danger">{{ errors.initiation_fee }}</div>
  </div>

  <div class="form-group">
    <label for="membershipFeeInput">Membership Fee *</label>
    <div class="row">
      <div class="input-group col-lg-3 col-md-4 col-sm-5">
        <div class="input-group-prepend">
          <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
        </div>
        <input id="membershipFeeInput" type="number" name="membership_fee"
               placeholder="XXX.XX" min="0" step="0.01"
               class="form-control"
               [(ngModel)]="membership.membership_fee"
               (ngModelChange)="changed.emit()">
      </div>
    </div>
    <div class="form-text text-danger">{{ errors.membership_fee }}</div>
  </div>

</ng-container>

<ng-container *ngIf="membership.is_group">

  <div class="form-group row">
    <div class="col-lg-6 col-md-8">
      <label for="adultTierNameInput">Base Tier Name *</label>
      <input id="adultTierNameInput" type="text" name="adult_tier_name"
             class="form-control"
             [(ngModel)]="membership.adult_tier_name"
             (ngModelChange)="changed.emit()">
      <div class="form-text text-danger">{{ errors.adult_tier_name }}</div>
    </div>
  </div>

  <div class="form-group">
    <div class="form-check"
         [ngbTooltip]="isExistingNonDraftMembership ? 'May not be changed for an existing non-draft membership.' : null">
      <input id="hasYouthTierCheckbox" type="checkbox" name="has_youth_tier"
             class="form-check-input"
             [(ngModel)]="membership.has_youth_tier"
             (ngModelChange)="ensureGroupTierDefaults(membership); changed.emit();"
             [disabled]="isExistingNonDraftMembership">
      <label class="form-check-label" for="hasYouthTierCheckbox">
        Include younger tier
      </label>
    </div>
    <div class="form-text text-danger">{{ errors.has_youth_tier }}</div>
  </div>

  <div class="form-group" *ngIf="membership.has_youth_tier">
    <label for="adultMinAgeInput">{{ membership.adult_tier_name }} minimum age</label>
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-5">
        <input id="adultMinAgeInput" type="number" name="adult_min_age"
               min="0" max="100" step="1"
               class="form-control"
               [(ngModel)]="membership.adult_min_age"
               (ngModelChange)="changed.emit()">
      </div>
    </div>
    <div class="form-text text-danger">{{ errors.adult_min_age }}</div>
  </div>

  <div class="form-group row" *ngIf="membership.has_youth_tier">
    <div class="col-lg-6 col-md-8">
      <label for="youthTierNameInput">Younger Tier Name *</label>
      <input id="youthTierNameInput" type="text" name="youth_tier_name"
             class="form-control"
             [(ngModel)]="membership.youth_tier_name"
             (ngModelChange)="changed.emit()">
      <div class="form-text text-danger">{{ errors.youth_tier_name }}</div>
    </div>
  </div>

  <div class="form-group">
    <label for="minNumMembersInput">
      Minimum number of members required for membership *
    </label>
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-5">
        <input id="minNumMembersInput" type="number" name="minimum_num_members"
               min="0" max="100" step="1"
               class="form-control"
               [(ngModel)]="membership.minimum_num_members"
               (ngModelChange)="changed.emit()">
      </div>
    </div>
    <small class="form-text text-muted" *ngIf="membership.has_youth_tier">
      This applies to the number of members overall. Minimums by age tier may also be configured below.
    </small>
    <div class="form-text text-danger">{{ errors.minimum_num_members }}</div>
  </div>

  <div class="form-group" *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
    <label for="initiationFeeGroupInput">Initiation Fee *</label>
    <div class="row">
      <div class="input-group col-lg-3 col-md-4 col-sm-5">
        <div class="input-group-prepend">
          <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
        </div>
        <input id="initiationFeeGroupInput" type="number" name="initiation_fee"
               placeholder="XXX.XX" min="0" step="0.01"
               class="form-control"
               [(ngModel)]="membership.initiation_fee"
               (ngModelChange)="changed.emit()">
      </div>
    </div>
    <div class="form-text text-danger">{{ errors.initiation_fee }}</div>
  </div>

  <div class="form-group row">
    <div class="col-lg-3 col-md-4 col-sm-6">
      <label for="adultBaseFeeInput">Base Fee per {{ membership.adult_tier_name }} *</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
        </div>
        <input id="adultBaseFeeInput" type="number" name="adult_base_fee"
               placeholder="XXX.XX" min="0" step="0.01"
               class="form-control"
               [(ngModel)]="membership.adult_base_fee"
               (ngModelChange)="changed.emit()">
      </div>
      <div class="form-text text-danger">{{ errors.adult_base_fee }}</div>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-6" *ngIf="membership.has_youth_tier">
      <label for="youthBaseFeeInput">Base Fee per {{ membership.youth_tier_name }} *</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
        </div>
        <input id="youthBaseFeeInput" type="number" name="youth_base_fee"
               placeholder="XXX.XX" min="0" step="0.01"
               class="form-control"
               [(ngModel)]="membership.youth_base_fee"
               (ngModelChange)="changed.emit()">
      </div>
      <div class="form-text text-danger">{{ errors.youth_base_fee }}</div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-lg-6 col-md-8">
      <label for="discountTypeSelect">Discounts Represented As *</label>
      <select id="discountTypeSelect" name="discount_type"
              class="custom-select"
              [(ngModel)]="membership.discount_type"
              (ngModelChange)="changed.emit()">
        <option [ngValue]="MembershipDiscountType.currency">
          {{ orgConfig.getCurrencyName() }} amounts
        </option>
        <option [ngValue]="MembershipDiscountType.percentage">Percentages</option>
      </select>
      <div class="form-text text-danger">{{ errors.discount_type }}</div>
    </div>
  </div>

  <div class="form-group">
    <div class="form-check">
      <input id="discountsAreIncrementalCheckbox" type="checkbox" name="discounts_are_incremental"
             class="form-check-input"
             [(ngModel)]="membership.discounts_are_incremental"
             (ngModelChange)="changed.emit()">
      <label class="form-check-label" for="discountsAreIncrementalCheckbox">
        Discounts are applied incrementally
      </label>
    </div>
    <small class="form-text text-muted">
      If this is checked, then discounts will be applied only to the member at each number. If this is left unchecked, then discounts are applied to all members when the count is reached. See the Pricing Matrix Preview to ensure that discounts are being calculated in the desired fashion.
    </small>
    <div class="form-text text-danger">{{ errors.discounts_are_incremental }}</div>
  </div>

  <div class="form-group"
       *ngIf="(membership.purchase_type === MembershipPurchaseType.recurring) && !membership.discounts_are_incremental">
    <div class="form-check">
      <input id="discounts_apply_to_individually_frozen_members"
             name="discounts_apply_to_individually_frozen_members"
             type="checkbox"
             class="form-check-input"
             [(ngModel)]="membership.discounts_apply_to_individually_frozen_members"
             (ngModelChange)="changed.emit()">
      <label class="form-check-label" for="discounts_apply_to_individually_frozen_members">
        Individually frozen members counts towards discount tiers
      </label>
    </div>
    <small class="form-text text-muted">
      If this is checked, then individually frozen members will still count towards the discount tier (potentially resulting in a lower price than if the frozen members were ignored). If this is left unchecked, then the membership fee calculation will ignore any individually frozen members.
    </small>
    <div class="form-text text-danger">{{ errors.discounts_apply_to_individually_frozen_members }}</div>
  </div>

  <hr class="my-4">

  <div class="rounded-table-wrapper mb-1">
    <table class="table">

      <thead>
      <tr>
        <th># in {{ membership.adult_tier_name }} Tier</th>
        <th>Discount per {{ membership.adult_tier_name }}</th>
        <th>Price per {{ membership.adult_tier_name }}</th>
        <th></th>
      </tr>
      </thead>

      <tbody>
      <tr *ngFor="let adultDiscount of membership.adult_discounts">
        <td>{{ adultDiscount.number_in_tier }}</td>
        <td class="table-button-cell">
          <div class="input-group input-group-sm" style="max-width: 150px">
            <div class="input-group-prepend"
                 *ngIf="membership.discount_type === MembershipDiscountType.currency">
              <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
            </div>
            <input class="form-control form-control-sm"
                   type="number" step="0.01" min="0"
                   [(ngModel)]="adultDiscount.discount_amount"
                   (ngModelChange)="changed.emit()"
                   [ngModelOptions]="{standalone: true}">
            <div class="input-group-append"
                 *ngIf="membership.discount_type === MembershipDiscountType.percentage">
              <span class="input-group-text">%</span>
            </div>
          </div>
        </td>
        <td>{{ orgConfig.getCurrencySymbol() }}{{ getDiscountedPrice(membership.adult_base_fee, adultDiscount.discount_amount) | number:'1.2-2' }}</td>
        <td class="table-button-cell">
          <button type="button" class="btn btn-outline-danger btn-sm float-right"
                  *ngIf="(adultDiscount.number_in_tier === membership.adult_discounts.length) && membership.adult_discounts.length > 1"
                  (click)="membership.adult_discounts.pop(); changed.emit();">
            Remove
          </button>
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <button type="button" class="btn btn-outline-primary mb-3"
          (click)="addAdultDiscount(); changed.emit();">
    Add Option
  </button>

  <p *ngIf="errors.adult_discounts" class="text-danger">{{ errors.adult_discounts }}</p>

  <div class="form-group">
    <label for="allowUnlimitedAdultsSelect">
      Can more than
      <b>{{ membership.adult_discounts.length }} {{ membership.adult_tier_name|lowercase }}s</b>
      be part of one group membership?
    </label>
    <div class="row">
      <div class="col-lg-6 col-md-8">
        <select id="allowUnlimitedAdultsSelect" name="allow_unlimited_adults"
                class="custom-select"
                [(ngModel)]="membership.allow_unlimited_adults"
                (ngModelChange)="changed.emit()">
          <option [ngValue]="false">No</option>
          <option [ngValue]="true">Yes</option>
        </select>
      </div>
    </div>
    <small class="form-text text-muted">
      If yes, additional {{ membership.adult_tier_name|lowercase }}s
      will be given the same discount as {{ membership.adult_discounts.length }}
      {{ membership.adult_tier_name|lowercase }}s.
    </small>
    <div class="form-text text-danger">{{ errors.allow_unlimited_adults }}</div>
  </div>

  <div class="form-group" *ngIf="membership.has_youth_tier">
    <label for="minNumAdultsInput">
      Minimum number of
      <b>{{ membership.adult_tier_name|lowercase }}s</b>
      required for membership *
    </label>
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-5">
        <input id="minNumAdultsInput" type="number" name="minimum_num_adults"
               min="0" max="100" step="1"
               class="form-control"
               [(ngModel)]="membership.minimum_num_adults"
               (ngModelChange)="changed.emit()">
      </div>
    </div>
    <div class="form-text text-danger">{{ errors.minimum_num_adults }}</div>
  </div>

  <hr class="my-4">

  <ng-container *ngIf="membership.has_youth_tier">

    <div class="rounded-table-wrapper mb-1">
      <table class="table">

        <thead>
        <tr>
          <th># in {{ membership.youth_tier_name }} Tier</th>
          <th>Discount per {{ membership.youth_tier_name }}</th>
          <th>Price per {{ membership.youth_tier_name }}</th>
          <th></th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let youthDiscount of membership.youth_discounts">
          <td>{{ youthDiscount.number_in_tier }}</td>
          <td class="table-button-cell">
            <div class="input-group input-group-sm" style="max-width: 150px">
              <div class="input-group-prepend"
                   *ngIf="membership.discount_type === MembershipDiscountType.currency">
                <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
              </div>
              <input class="form-control form-control-sm"
                     type="number" step="0.01" min="0"
                     [(ngModel)]="youthDiscount.discount_amount"
                     (ngModelChange)="changed.emit()"
                     [ngModelOptions]="{standalone: true}">
              <div class="input-group-append"
                   *ngIf="membership.discount_type === MembershipDiscountType.percentage">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </td>
          <td>{{ orgConfig.getCurrencySymbol() }}{{ getDiscountedPrice(membership.youth_base_fee, youthDiscount.discount_amount) | number:'1.2-2' }}</td>
          <td class="table-button-cell">
            <button type="button" class="btn btn-outline-danger btn-sm float-right"
                    *ngIf="(youthDiscount.number_in_tier === membership.youth_discounts.length) && membership.youth_discounts.length > 1"
                    (click)="membership.youth_discounts.pop(); changed.emit();">
              Remove
            </button>
          </td>
        </tr>
        </tbody>

      </table>
    </div>

    <button type="button" class="btn btn-outline-primary mb-3"
            (click)="addYouthDiscount(); changed.emit();">
      Add Option
    </button>

    <p *ngIf="errors.youth_discounts" class="text-danger">{{ errors.youth_discounts }}</p>

    <div class="form-group">
      <label for="allowUnlimitedYouthsSelect">
        Can more than <b>{{ membership.youth_discounts.length }}
        {{ membership.youth_tier_name|lowercase }}s</b>
        be part of one group membership?
      </label>
      <div class="row">
        <div class="col-lg-6 col-md-8">
          <select id="allowUnlimitedYouthsSelect" name="allow_unlimited_youths"
                  class="custom-select"
                  [(ngModel)]="membership.allow_unlimited_youths"
                  (ngModelChange)="changed.emit()">
            <option [ngValue]="false">No</option>
            <option [ngValue]="true">Yes</option>
          </select>
        </div>
      </div>
      <small class="form-text text-muted">
        If yes, additional {{ membership.youth_tier_name|lowercase }}s
        will be given the same discount as {{ membership.youth_discounts.length }}
        {{ membership.youth_tier_name|lowercase }}s.
      </small>
      <div class="form-text text-danger">{{ errors.allow_unlimited_youths }}</div>
    </div>

  <div class="form-group" *ngIf="membership.has_youth_tier">
    <label for="minNumYouthsInput">
      Minimum number of
      <b>{{ membership.youth_tier_name|lowercase }}s</b>
      required for membership *
    </label>
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-5">
        <input id="minNumYouthsInput" type="number" name="minimum_num_youths"
               min="0" max="100" step="1"
               class="form-control"
               [(ngModel)]="membership.minimum_num_youths"
               (ngModelChange)="changed.emit()">
      </div>
    </div>
    <div class="form-text text-danger">{{ errors.minimum_num_youths }}</div>
  </div>

    <hr class="my-4">

  </ng-container><!-- Youth tier discounts -->

  <h5 class="mt-3">Pricing Matrix Preview</h5>

  <ng-container *ngIf="!membership.has_youth_tier">
    <div class="rounded-table-wrapper" style="max-width: 200px">
      <table class="table">
        <tbody>
        <tr *ngFor="let adultNum of getPricingMatrixAdultNums()">
          <th>
            {{ adultNum }} {{ membership.adult_tier_name }}{{ adultNum === 1 ? '' : 's' }}
          </th>
          <td>
            <ng-container *ngIf="memberNumAllowed(adultNum, 0)">
              {{ orgConfig.getCurrencySymbol() }}{{ getGroupPrice(adultNum, 0) }}
            </ng-container>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </ng-container><!-- Pricing matrix - no youth tier -->

  <ng-container *ngIf="membership.has_youth_tier">
    <div class="rounded-table-wrapper">
      <table class="table">
        <thead>
        <tr>
          <th></th>
          <th *ngFor="let adultNum of getPricingMatrixAdultNums()">
            {{ adultNum }} {{ membership.adult_tier_name }}{{ adultNum === 1 ? '' : 's' }}
          </th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let youthNum of getPricingMatrixYouthNums()">
          <th>
            {{ youthNum }} {{ membership.youth_tier_name }}{{ youthNum === 1 ? '' : 's' }}
          </th>
          <td *ngFor="let adultNum of getPricingMatrixAdultNums()">
            <ng-container *ngIf="memberNumAllowed(adultNum, youthNum)">
              {{ orgConfig.getCurrencySymbol() }}{{ getGroupPrice(adultNum, youthNum) }}
            </ng-container>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </ng-container><!-- Pricing matrix - with youth tier -->

  <hr class="my-4">

</ng-container><!-- Group membership pricing -->

<div class="form-group">
  <label *ngIf="membership.is_group">Per-Customer Add-Ons</label>
  <label *ngIf="!membership.is_group">Membership Add-Ons</label>

  <table class="table table-bordered table-sm mb-1 border-0">
    <thead>
    <tr>
      <th>Name</th>
      <th>Fee</th>
      <th>Selectable by Customer?</th>
      <th>Icon</th>
      <th>Tax Rate</th>
      <th class="border-0 edit-and-remove-cell"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let addOn of membership.per_customer_add_ons; let addOnIdx = index;">
      <td>{{ addOn.name }}</td>
      <td>{{ orgConfig.getCurrencySymbol() }}{{ addOn.fee }}</td>
      <td>{{ addOn.is_visible ? 'Yes' : 'No' }}</td>
      <td style="padding:3px">
        <app-membership-icon [colorHex]="addOn.icon_color_hex" [iconInitials]="addOn.icon_initials"
                             [size]="0">
        </app-membership-icon>
      </td>
      <td>
        <!-- Nested span stops the tooltip from shifting the table -->
        <span [ngbTooltip]="(addOn.tax_rate_per_location) && (Object.keys(addOn.tax_rate_per_location).length > 0) ? 'This add-on has per-location tax rates' : ''">
          <span *ngIf="addOn.tax_rate_id === undefined" class="text-muted">
            {{ getTaxRateNameForId(membership.tax_rate_id) }}
          </span>
          <span *ngIf="addOn.tax_rate_id !== undefined">
            {{ getTaxRateNameForId(addOn.tax_rate_id) }}
          </span>
          <span *ngIf="(addOn.tax_rate_per_location) && (Object.keys(addOn.tax_rate_per_location).length > 0)">
            *
          </span>
        </span>
      </td>
      <td class="border-0 edit-and-remove-cell">
        <button type="button" class="btn btn-sm btn-outline-primary ml-1"
                (click)="editPerCustomerAddOn(addOn)">
          Edit
        </button>
        <button type="button" class="btn btn-sm btn-outline-danger ml-1"
                (click)="removePerCustomerAddOn(addOnIdx)">
          Remove
        </button>
      </td>
    </tr>
    <tr *ngIf="membership.per_customer_add_ons.length === 0">
      <td colspan="5" class="text-muted">No Per-Customer Add-Ons Configured</td>
    </tr>
    </tbody>
  </table>

  <button type="button" class="btn btn-sm btn-outline-primary"
          (click)="addPerCustomerAddOn()">
    <ng-container *ngIf="membership.is_group">Add Per-Customer Add-On</ng-container>
    <ng-container *ngIf="!membership.is_group">Add Membership Add-On</ng-container>
  </button>

  <div class="form-text text-danger">{{ errors.per_customer_add_ons }}</div>
</div>

<div class="row">
  <div class="mb-2 col-lg-8 col-md-10">
    <label for="taxRateSelect">Tax Rate *</label>
    <div class="float-right mb-1">
      <a href="#"
         (click)="$event.preventDefault();refreshTaxRates.emit();">
        Refresh Tax Rates
      </a>
      |
      <a routerLink="/tax-rates-config" target="_blank">
        Configure Tax Rates
      </a>
    </div>
    <select id="taxRateSelectLoading" class="custom-select" name="tax_rate"
            *ngIf="loadingTaxRates" disabled>
      <option>Loading...</option>
    </select>
    <select id="taxRateSelect" class="custom-select" name="tax_rate"
            *ngIf="!loadingTaxRates"
            [(ngModel)]="membership.tax_rate_id"
            (ngModelChange)="changed.emit()">
      <option *ngIf="taxRateRemoved(membership.tax_rate_id)"
              [ngValue]="membership.tax_rate_id">
        {{ membership.tax_rate_name }} (Removed)
      </option>
      <option *ngFor="let taxRate of taxRates"
              [ngValue]="taxRate.id">
        {{ taxRate.name }} - {{ taxRate.rate_percent }}%
      </option>
    </select>
    <div class="form-text text-danger">{{ errors.tax_rate }}</div>
  </div>
</div>

<div class="row" *ngIf="locations && (locations.length > 1)">
  <div class="form-group col-lg-8 col-md-10">
    <div class="indented-subsection">
      <div class="form-check mb-2">
        <input type="checkbox"
               id="hasPerLocationTaxRates"
               name="hasPerLocationTaxRates"
               class="form-check-input"
               [(ngModel)]="hasPerLocationTaxRates"
               (ngModelChange)="hasPerLocationTaxRatesChange.emit($event); changed.emit()">
        <label class="form-check-label" for="hasPerLocationTaxRates">
          Configure tax rate by location
        </label>
      </div>

      <ng-container *ngIf="hasPerLocationTaxRates">
        <p class="text-muted mb-2" *ngIf="Object.keys(membership.tax_rate_per_location).length === 0">
          No locations selected
        </p>

        <div class="mb-2" *ngFor="let locId of Object.keys(membership.tax_rate_per_location)">
          <div class="row">
            <div class="col-5 pr-0">
              <input type="text"
                     class="form-control form-control-sm disabled"
                     disabled
                     value="{{ getLocNameById(locId) }}">
            </div>
            <div class="col-5 pr-0">
              <select class="custom-select custom-select-sm"
                      *ngIf="loadingTaxRates" disabled>
                <option>Loading...</option>
              </select>
              <select class="custom-select custom-select-sm"
                      name="tax_rate{{ locId }}"
                      *ngIf="!loadingTaxRates"
                      [(ngModel)]="membership.tax_rate_per_location[locId]"
                      (ngModelChange)="changed.emit()">
                <option *ngIf="taxRateRemoved(membership.tax_rate_per_location[locId])"
                        [ngValue]="membership.tax_rate_per_location[locId]">
                  (Removed Tax Rate)
                </option>
                <option *ngFor="let taxRate of taxRates"
                        [ngValue]="taxRate.id">
                  {{ taxRate.name }} - {{ taxRate.rate_percent }}%
                </option>
              </select>
            </div>
            <div class="col-2">
              <button class="btn btn-sm btn-danger"
                      (click)="changed.emit(); deleteProp(membership.tax_rate_per_location, locId);">
                X
              </button>
            </div>
          </div>
        </div>

        <button class="btn btn-sm btn-outline-primary d-block"
                type="button"
                [disabled]="loadingTaxRates || (taxRates.length === 0)"
                [class.disabled]="loadingTaxRates || (taxRates.length === 0)"
                (click)="addTaxRateLocation()">
          Add Location
        </button>

        <div class="form-text text-danger">{{ errors.tax_rate_per_location }}</div>
        <small class="form-text text-muted">
          A per-location tax rate will replace the default tax rate configured above.
        </small>
      </ng-container>
    </div>
  </div>
</div>

<div class="row">
  <div class="mb-2 col-lg-8 col-md-10">
    <label for="taxRateInitFeeSelect">Initiation Fee Tax Rate *</label>
    <div class="float-right mb-1">
      <a href="#"
         (click)="$event.preventDefault();refreshTaxRates.emit();">
        Refresh Tax Rates
      </a>
      |
      <a routerLink="/tax-rates-config" target="_blank">
        Configure Tax Rates
      </a>
    </div>
    <select id="taxRateInitFeeSelectLoading" class="custom-select" name="tax_rate_initiation_fee"
            *ngIf="loadingTaxRates" disabled>
      <option>Loading...</option>
    </select>
    <select id="taxRateInitFeeSelect" class="custom-select" name="tax_rate_initiation_fee"
            *ngIf="!loadingTaxRates"
            [(ngModel)]="membership.tax_rate_initiation_fee_id"
            (ngModelChange)="changed.emit()">
      <option *ngIf="taxRateRemoved(membership.tax_rate_initiation_fee_id)"
              [ngValue]="membership.tax_rate_initiation_fee_id">
        {{ membership.tax_rate_initiation_fee_name }} (Removed)
      </option>
      <option *ngFor="let taxRate of taxRates"
              [ngValue]="taxRate.id">
        {{ taxRate.name }} - {{ taxRate.rate_percent }}%
      </option>
    </select>
    <div class="form-text text-danger">{{ errors.tax_rate_initiation_fee }}</div>
  </div>
</div>

<div class="row" *ngIf="locations && (locations.length > 1)">
  <div class="form-group col-lg-8 col-md-10">
    <div class="indented-subsection">
      <div class="form-check mb-2">
        <input type="checkbox"
               id="hasPerLocationInitiationFeeTaxRates"
               name="hasPerLocationInitiationFeeTaxRates"
               class="form-check-input"
               [(ngModel)]="hasPerLocationInitiationFeeTaxRates"
               (ngModelChange)="hasPerLocationInitiationFeeTaxRatesChange.emit($event); changed.emit()">
        <label class="form-check-label" for="hasPerLocationInitiationFeeTaxRates">
          Configure tax rate by location
        </label>
      </div>

      <ng-container *ngIf="hasPerLocationInitiationFeeTaxRates">
        <p class="text-muted mb-2" *ngIf="Object.keys(membership.tax_rate_initiation_fee_per_location).length === 0">
          No locations selected
        </p>

        <div class="mb-2" *ngFor="let locId of Object.keys(membership.tax_rate_initiation_fee_per_location)">
          <div class="row">
            <div class="col-5 pr-0">
              <input type="text"
                     class="form-control form-control-sm disabled"
                     disabled
                     value="{{ getLocNameById(locId) }}">
            </div>
            <div class="col-5 pr-0">
              <select class="custom-select custom-select-sm"
                      *ngIf="loadingTaxRates" disabled>
                <option>Loading...</option>
              </select>
              <select class="custom-select custom-select-sm"
                      name="tax_rate_initiation_fee{{ locId }}"
                      *ngIf="!loadingTaxRates"
                      [(ngModel)]="membership.tax_rate_initiation_fee_per_location[locId]"
                      (ngModelChange)="changed.emit()">
                <option *ngIf="taxRateRemoved(membership.tax_rate_initiation_fee_per_location[locId])"
                        [ngValue]="membership.tax_rate_initiation_fee_per_location[locId]">
                  (Removed Tax Rate)
                </option>
                <option *ngFor="let taxRate of taxRates"
                        [ngValue]="taxRate.id">
                  {{ taxRate.name }} - {{ taxRate.rate_percent }}%
                </option>
              </select>
            </div>
            <div class="col-2">
              <button class="btn btn-sm btn-danger"
                      (click)="changed.emit(); deleteProp(membership.tax_rate_initiation_fee_per_location, locId);">
                X
              </button>
            </div>
          </div>
        </div>

        <button class="btn btn-sm btn-outline-primary d-block"
                type="button"
                [disabled]="loadingTaxRates || (taxRates.length === 0)"
                [class.disabled]="loadingTaxRates || (taxRates.length === 0)"
                (click)="addTaxRateInitiationFeeLocation()">
          Add Location
        </button>

        <div class="form-text text-danger">{{ errors.tax_rate_initiation_fee_per_location }}</div>
        <small class="form-text text-muted">
          A per-location tax rate will replace the default initiation fee tax rate configured above.
        </small>
      </ng-container>
    </div>
  </div>
</div>

<div class="form-group"  *ngIf="locations && (locations.length > 1)">
  <label>Location-Specific Pricing Policies</label>

  <table class="table table-bordered table-sm mb-1 border-0">
    <thead>
    <tr>
      <th>Locations</th>
      <th>Pricing Summary</th>
      <th class="border-0 edit-and-remove-cell"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let pricingMatrix of membership.location_specific_pricing_matrices; let matIdx = index;">
      <td>
        <span class="d-block" *ngFor="let locId of pricingMatrix.location_ids">
          {{ getLocNameById(locId) }}
        </span>
      </td>
      <td>
        <ng-container *ngIf="!membership.is_group">
          <span class="d-block">
            Base fee:
            <b>{{ orgConfig.formatCurrency(pricingMatrix.membership_fee)}}</b>
          </span>
        </ng-container>
        <ng-container *ngIf="membership.is_group">
          <span class="d-block">
            Base {{ membership.adult_tier_name }} fee:
            <b>{{ orgConfig.formatCurrency(pricingMatrix.adult_base_fee)}}</b>
          </span>
          <span class="d-block" *ngIf="membership.has_youth_tier">
            Base {{ membership.youth_tier_name }} fee:
            <b>{{ orgConfig.formatCurrency(pricingMatrix.youth_base_fee)}}</b>
          </span>
        </ng-container>
        <span class="d-block">
          Initiation fee:
          <b>{{ orgConfig.formatCurrency(pricingMatrix.initiation_fee)}}</b>
        </span>
        <span class="d-block" *ngFor="let addOn of membership.per_customer_add_ons">
          {{ addOn.name }} add-on:
          <b *ngIf="getPricingMatrixAddOnFee(pricingMatrix, addOn) !== null">
            {{ orgConfig.formatCurrency(getPricingMatrixAddOnFee(pricingMatrix, addOn)) }}
          </b>
          <span class="text-muted" *ngIf="getPricingMatrixAddOnFee(pricingMatrix, addOn) === null">
            Not available
          </span>
        </span>
      </td>
      <td class="border-0 edit-and-remove-cell">
        <button type="button" class="btn btn-sm btn-outline-primary ml-1"
                (click)="editPricingMatrix(matIdx)">
          Edit
        </button>
        <button type="button" class="btn btn-sm btn-outline-danger ml-1"
                (click)="removePricingMatrix(matIdx)">
          Remove
        </button>
      </td>
    </tr>
    <tr *ngIf="membership.location_specific_pricing_matrices.length === 0">
      <td colspan="2" class="text-muted">No Per-Location Pricing Policies Configured</td>
    </tr>
    </tbody>
  </table>

  <button type="button" class="btn btn-sm btn-outline-primary"
          (click)="addPricingMatrix()">
    Add Location-Specific Pricing Policy
  </button>

  <div class="form-text text-danger">
    {{ errors.location_specific_pricing_matrices }}
  </div>
</div>

<div class="form-group" *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
  <label>Upfront Payment Options</label>

  <table class="table table-bordered table-sm mb-1 border-0">
    <thead>
    <tr>
      <th>Time Period</th>
      <th>Discount</th>
      <th class="border-0 edit-and-remove-cell"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let upo of membership.upfront_payment_options; let upoIdx = index;">
      <td>
        {{ upo.number_of_periods }} {{ getMembershipIntervalDisplaySingle(membership.interval) }}s
        <ng-container *ngIf="upo.min_time_without_active_or_frozen_membership_days">
          <br>
          <small class="text-muted">
            Requires no membership in past {{ upo.min_time_without_active_or_frozen_membership_days }} days
          </small>
        </ng-container>
        <ng-container *ngIf="upo.available_start_date || upo.available_end_date">
          <br>
          <small class="text-muted">
            <ng-container *ngIf="upo.available_start_date && upo.available_end_date">
              Available {{ dateStringFromISO8601(upo.available_start_date) }} to {{ dateStringFromISO8601(upo.available_end_date) }}
            </ng-container>
            <ng-container *ngIf="upo.available_start_date && !upo.available_end_date">
              Available from {{ dateStringFromISO8601(upo.available_start_date) }}
            </ng-container>
            <ng-container *ngIf="!upo.available_start_date && upo.available_end_date">
              Available until {{ dateStringFromISO8601(upo.available_end_date) }}
            </ng-container>
          </small>
        </ng-container>
      </td>
      <td>
        <ng-container *ngIf="upo.discount_type === MembershipDiscountType.currency">
          {{ orgConfig.formatCurrency(upo.discount_amount) }}
        </ng-container>
        <ng-container *ngIf="upo.discount_type === MembershipDiscountType.percentage">
          {{ upo.discount_amount }}%
        </ng-container>
      </td>
      <td class="border-0 edit-and-remove-cell">
        <button type="button" class="btn btn-sm btn-outline-primary ml-1"
                (click)="editUpfrontPaymentOption(upoIdx)">
          Edit
        </button>
        <button type="button" class="btn btn-sm btn-outline-danger ml-1"
                (click)="removeUpfrontPaymentOption(upoIdx)">
          Remove
        </button>
      </td>
    </tr>
    <tr *ngIf="membership.upfront_payment_options.length === 0">
      <td colspan="2" class="text-muted">No Upfront Payment Options Configured</td>
    </tr>
    </tbody>
  </table>

  <button type="button" class="btn btn-sm btn-outline-primary"
          (click)="addUpfrontPaymentOption()">
    Add Upfront Payment Option
  </button>

  <small class="form-text text-muted">
    Upfront payment options allow a customer to pay for multiple time periods when the membership is initially purchased, in exchange for a discount. Once the paid-upfront period has ended, the membership will begin regular recurring billing at the standard price point. An option with a start or end date is only offered between those dates.
  </small>

  <div class="alert alert-info mt-2" *ngIf="membership.bill_day_of_month">
    Because this membership has a configured "Billing day of month", the customer will be charged the pro-rated amount in addition to the selected upfront period.
    <br><br>
    For example, if the custom chooses to pay 2 months upfront for a $20 discount, and the membership's fee is $100 a month with a set bill date of the 1st, if a customer buys a membership on June 16, they will be charged $50 (pro-rated dues) + $200 (2x$100 monthly dues) - $20 (discount). If it is a percentage discount, it will only be applied to the full upfront period, so if in the same example it was 10% off the first full two months, it would be $50 + $180 (0.9 * $200). On September 1st, the upfront period would end and they would be charged the normal monthly dues.
  </div>

  <div class="form-text text-danger">
    {{ errors.upfront_payment_options }}
  </div>
</div>
